(function () {
  'use strict';

  var roots = [];

  function is360PreviewEnabled() {
    return window.RABITAT_360_PREVIEW_ENABLED === true;
  }

  function getVariantInput() {
    return document.querySelector('[data-product-variant-id], input[name="id"]');
  }

  function getCurrentVariantId() {
    var input = getVariantInput();
    return input && input.value ? String(input.value) : null;
  }

  function getVariantData(variantId) {
    var id = variantId || getCurrentVariantId();
    if (!id || !window.personalizationData) return null;
    return window.personalizationData[id] || null;
  }

  function normalizeGlbUrl(url) {
    if (url == null || url === 'null' || url === 'undefined') return null;
    url = String(url).trim();
    if (!url.length) return null;
    if (/\.usdz(\?|#|$)/i.test(url)) {
      return url.replace(/\.usdz(?=[?#]|$)/i, '.glb');
    }
    return url;
  }

  function getVariantGlbMap() {
    if (window.__rabitatVariantGlbMap) return window.__rabitatVariantGlbMap;

    var el = document.querySelector('[data-variant-glb-map]');
    if (!el) return {};

    try {
      window.__rabitatVariantGlbMap = JSON.parse(el.textContent);
    } catch (error) {
      window.__rabitatVariantGlbMap = {};
    }

    return window.__rabitatVariantGlbMap;
  }

  function getGlbUrlFromSwatch(variantId) {
    var swatch = document.querySelector('[data-glb-url][data-variant-id="' + variantId + '"]');
    return swatch ? swatch.getAttribute('data-glb-url') : null;
  }

  function getGlbUrl(variantId) {
    var id = variantId || getCurrentVariantId();
    if (!id) return null;

    var variantData = getVariantData(id);
    var map = getVariantGlbMap();
    var fromSwatch = getGlbUrlFromSwatch(id);

    return normalizeGlbUrl(
      (variantData && variantData.glbUrl) ||
        map[id] ||
        fromSwatch
    );
  }

  function getPosterUrlForRoot(root) {
    if (root.hasAttribute('data-pdp-hero-inline-3d-root')) {
      var hero = document.querySelector('[data-product-hero]');
      if (!hero) return null;
      var heroImg = hero.querySelector(
        '.rabitat-product-page__hero-image:not(.rabitat-product-page__hero-image--placeholder)'
      );
      return heroImg && heroImg.src ? heroImg.src : null;
    }

    var img = root.querySelector('#personalizationProductImage, [data-inline-3d-poster]');
    return img && img.src ? img.src : null;
  }

  function getCameraOrbit(variantId) {
    var variantData = getVariantData(variantId);
    return (variantData && variantData.glbCameraOrbit) || '0deg 75deg auto';
  }

  function getCameraTarget(variantId) {
    var variantData = getVariantData(variantId);
    return (variantData && variantData.glbCameraTarget) || 'auto auto auto';
  }

  function updatePreview360Button(entry) {
    var previewBtn = entry.previewBtn;
    if (!previewBtn) return;

    if (!is360PreviewEnabled()) {
      previewBtn.hidden = true;
      previewBtn.setAttribute('hidden', '');
      previewBtn.disabled = true;
      previewBtn.setAttribute('aria-disabled', 'true');
      previewBtn.title = '';
      return;
    }

    var glbUrl = getGlbUrl(entry.variantId);

    if (!glbUrl) {
      previewBtn.hidden = true;
      previewBtn.setAttribute('hidden', '');
      previewBtn.disabled = true;
      previewBtn.setAttribute('aria-disabled', 'true');
      previewBtn.title = '';
      return;
    }

    previewBtn.hidden = false;
    previewBtn.removeAttribute('hidden');
    previewBtn.disabled = false;
    previewBtn.setAttribute('aria-disabled', 'false');
    previewBtn.title = 'View bottle in 360°';

    if (window.RabitatInline3d) {
      if (window.RabitatInline3d.ensureModelViewer) {
        window.RabitatInline3d.ensureModelViewer().catch(function () {});
      }
      if (window.RabitatInline3d.prefetchAsset) {
        window.RabitatInline3d.prefetchAsset(glbUrl);
      }
    }
  }

  function initInline3d(entry) {
    if (!is360PreviewEnabled() || !window.RabitatInline3d || !entry.root) return;

    entry.inline3dApi = window.RabitatInline3d.init(entry.root, {
      getGlbUrl: function () {
        return getGlbUrl(entry.variantId);
      },
      getPosterUrl: function () {
        return getPosterUrlForRoot(entry.root);
      },
      canOpen: function () {
        return !!getGlbUrl(entry.variantId);
      },
      getHotspotPoints: function () {
        return [];
      },
      getCameraOrbit: function () {
        return getCameraOrbit(entry.variantId);
      },
      getCameraTarget: function () {
        return getCameraTarget(entry.variantId);
      },
      onError: function () {
        window.alert('Unable to load 3D preview. Please try again.');
      }
    });
  }

  function syncAllVariants() {
    var variantId = getCurrentVariantId();

    roots.forEach(function (entry) {
      entry.variantId = variantId;
      updatePreview360Button(entry);
      if (entry.inline3dApi && entry.inline3dApi.isOpen()) {
        entry.inline3dApi.close();
      }
    });
  }

  function bindEvents() {
    document.addEventListener('rabitat:variant:changed', syncAllVariants);
    document.addEventListener('variant:changed', syncAllVariants);

    document.addEventListener('change', function (event) {
      if (
        event.target &&
        (event.target.name === 'id' || event.target.matches('[data-product-variant-id]'))
      ) {
        syncAllVariants();
      }
    });
  }

  function initRoot(root) {
    var previewBtn = root.querySelector('[data-inline-3d-toggle]');
    if (!previewBtn) return;

    var entry = {
      root: root,
      previewBtn: previewBtn,
      variantId: getCurrentVariantId(),
      inline3dApi: null
    };

    initInline3d(entry);
    updatePreview360Button(entry);
    roots.push(entry);
  }

  function init() {
    if (!is360PreviewEnabled()) return;

    document.querySelectorAll('[data-inline-3d-root]').forEach(initRoot);
    bindEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
